<template>
    <!-- Auth redesign — регистрация (B0–B3) в AuthShell. Макет Claude Design. -->
    <div class="auth-form reg-form" :class="{ 'is-result': this.done }">
        <button v-if="!this.done" type="button" class="reg-close" id="c-rr-1" v-on:click="this.$emit('updateParentState')" aria-label="Close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6 6 18"/></svg>
        </button>

        <template v-if="!this.done">
        <div class="form-head">
            <h1 class="form-title">{{ $t('components.service.Registration.1') }}</h1>
        </div>

        <Stages @updateParentState="this.updateStage" :stage="this.stage" :stages="this.stages" style="margin-bottom: 28px"/>

        <!-- B0 — тип аккаунта -->
        <div v-if="this.stage == '0'" key="st-reg-0" class="type-grid">
            <button type="button" class="type-card" :class="{ sel: this.usertype == '1' }" id="c-rr-2" v-on:click="this.selectType('1')">
                <span class="tc-radio"></span>
                <span class="tc-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M5 20a7 7 0 0 1 14 0"/></svg></span>
                <span class="tc-name">{{ $t('components.service.Registration.2') }}</span>
                <span class="tc-desc">{{ $t('components.service.Registration.44') }}</span>
            </button>
            <button type="button" class="type-card" :class="{ sel: this.usertype == '2' }" id="c-rr-3" v-on:click="this.selectType('2')">
                <span class="tc-radio"></span>
                <span class="tc-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="18" height="13" rx="2.5"/><path d="M8 7V5.5A1.5 1.5 0 0 1 9.5 4h5A1.5 1.5 0 0 1 16 5.5V7M3 12h18"/></svg></span>
                <span class="tc-name">{{ $t('components.service.Registration.3') }}</span>
                <span class="tc-desc">{{ $t('components.service.Registration.45') }}</span>
            </button>
        </div>

        <!-- B1 — данные пользователя -->
        <div v-if="this.stage == '1'" key="st-reg-1">
            <template v-if="this.usertype == '1' && this.reg_name == true">
                <div class="field">
                    <div class="field-label-row"><label class="field-label">{{ $t('components.service.Registration.4') }}</label></div>
                    <InputSimple id="surname" :dataValue="this.data.surname" :invalid="this.inpts.surname.warn" @blurInput="this.blurCheck" :success="this.inpts.surname.success" :invalidHint="$t('components.service.Registration.8')" :placeholder="$t('components.service.Registration.9')" @updateParentState="this.updateState"/>
                </div>
                <div class="field">
                    <div class="field-label-row"><label class="field-label">{{ $t('components.service.Registration.5') }}</label></div>
                    <InputSimple id="firstname" :dataValue="this.data.firstname" :invalid="this.inpts.firstname.warn" @blurInput="this.blurCheck" :success="this.inpts.firstname.success" :invalidHint="$t('components.service.Registration.10')" :placeholder="$t('components.service.Registration.11')" @updateParentState="this.updateState"/>
                </div>
                <div class="field">
                    <div class="field-label-row"><label class="field-label">{{ $t('components.service.Registration.6') }}</label></div>
                    <InputSimple id="patronymic" :dataValue="this.data.patronymic" :invalid="this.inpts.patronymic.warn" @blurInput="this.blurCheck" :success="this.inpts.patronymic.success" :invalidHint="$t('components.service.Registration.10')" :placeholder="$t('components.service.Registration.12')" @updateParentState="this.updateState"/>
                </div>
            </template>

            <div class="field">
                <div class="field-label-row"><label class="field-label">{{ $t('components.service.Registration.36') }}</label></div>
                <SelectSimple id="fact_country" :keywords.sync="this.countries_keywords" :dataValue="this.data.fact_country" :isSearch="true" :hotUpdate="true" @updateParentState="this.updateState"/>
            </div>

            <template v-if="this.usertype == '2'">
                <div class="field">
                    <div class="field-label-row"><label class="field-label">{{ $t('components.service.Registration.7') }}</label></div>
                    <InputSimple id="uname" :dataValue="this.data.uname" :invalid="this.inpts.uname.warn" @blurInput="this.blurCheck" :success="this.inpts.uname.success" :invalidHint="$t('components.service.Registration.13')" :placeholder="$t('components.service.Registration.14')" @updateParentState="this.updateState"/>
                </div>
                <div class="field">
                    <div class="field-label-row"><label class="field-label">{{ $t('components.service.Registration.35') }}</label></div>
                    <InputSimple id="legal_entity_identifier" :dataValue="this.data.legal_entity_identifier" :invalid="this.inpts.legal_entity_identifier.warn" @blurInput="this.blurCheck" :success="this.inpts.legal_entity_identifier.success" :invalidHint="$t('components.service.Registration.13')" :placeholder="$t('components.service.Registration.49')" @updateParentState="this.updateState"/>
                </div>
            </template>

            <div class="field">
                <div class="field-label-row"><label class="field-label">{{ $t('components.service.Registration.16') }}</label></div>
                <div class="email-wrap">
                    <InputSimple id="email" :dataValue="this.data.email" :placeholder="'example@some.dom'" :invalid="this.warn" :success="this.success" :invalidHint="this.warnHint" @updateParentState="this.updateState" @blurInput="this.blurCheck"/>
                    <span class="email-check-spinner">
                        <loading :active="this.loader" :is-full-page="false" :height="22" :width="22" :loader="'spinner'" :color="'#008D3E'" :opacity="0"/>
                    </span>
                </div>
            </div>
        </div>

        <!-- B2 — пароль -->
        <div v-if="this.stage == '2'" key="st-reg-2">
            <div class="field">
                <div class="field-label-row"><label class="field-label">{{ $t('components.service.Registration.17') }}</label></div>
                <InputSimple id="password" type="password" :autocomplete="'new-password'" :dataValue="this.data.password" @updateParentState="this.updateState"/>
                <PasswordMeter :value="this.data.password" @update:valid="(v) => this.pwValid = v"/>
            </div>
            <div class="field">
                <div class="field-label-row"><label class="field-label">{{ $t('components.service.Registration.19') }}</label></div>
                <InputSimple id="rep_password" type="password" :autocomplete="'new-password'" :dataValue="this.data.rep_password" :invalid="this.rep_pas_warn" :success="this.rep_pas_success" @updateParentState="this.updateState"/>
                <div v-if="this.data.rep_password.length" class="match-msg" :class="this.regMatch ? 'ok' : 'bad'">
                    <svg v-if="this.regMatch" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>
                    <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>
                    {{ this.regMatch ? $t('views.Login.61') : $t('components.service.Registration.20') }}
                </div>
            </div>
        </div>

        <!-- B3 — код подтверждения email -->
        <div v-if="this.stage == '3'" key="st-reg-3">
            <p class="form-sub" style="margin-bottom: 16px">{{ $t('components.service.Registration.37') }} <b>{{ this.data.email }}</b></p>
            <OtpInput :value="this.confirmCode" :invalid="this.confirmCodeError" @update:value="this.onConfirmCode"/>
            <div v-if="this.confirmCodeError && this.confirmCodeErrorText" role="alert" class="field-msg" style="margin-top: 8px"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>{{ this.confirmCodeErrorText }}</div>
            <button type="button" class="accent-link" style="margin-top: 12px; display: inline-block; background: none; border: none; padding: 0" v-on:click="this.changeEmail">{{ $t('components.service.Registration.46') }}</button>
            <div class="btn-row" style="margin-top: 18px">
                <Button :name="$t('components.service.Registration.40')" id="c-rr-resend" type="btn-outline-warning flex-none" :disabled="this.resendDisabled" :loader="this.resending" v-on:click="this.doResend()"/>
                <Button :name="$t('components.service.Registration.39')" id="c-rr-confirm" type="btn-warning flex-grow" :disabled="this.confirmCode.length != 6" :loader="this.confirming" v-on:click="this.doConfirm()"/>
            </div>
            <p v-if="this.resendDisabled" class="resend-row">{{ $t('components.service.Registration.41') }} {{ this.resendTimer }}s</p>
        </div>

        <!-- закрытие пробела: серверная ошибка registerMe без флагов error/modal -->
        <div v-if="this.submitError" role="alert" class="field-msg" style="margin-top: 18px"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>{{ this.submitError }}</div>

        <!-- навигация (не на шаге кода) -->
        <div v-if="this.stage != '3'" class="btn-row" style="margin-top: 26px">
            <Button :name="$t('components.service.Registration.21')" id="c-rr-6" type="btn-outline-warning flex-none" v-on:click="this.goBack()"/>
            <Button v-if="this.stage == '2'" :name="$t('components.service.Registration.22')" id="c-rr-7" type="btn-warning flex-grow" :disabled="!this.stages[this.stage].ready" :loader="this.submitting" v-on:click="this.goNext()"/>
            <Button v-else :name="$t('components.service.Registration.23')" id="c-rr-8" type="btn-warning flex-grow" :disabled="!this.stages[this.stage].ready" v-on:click="this.goNext()"/>
        </div>

        <!-- подвал: вход (на шаге 0) -->
        <div v-if="this.stage == '0'" class="form-foot">{{ $t('components.service.Registration.47') }} <span class="accent-link" v-on:click="this.$emit('updateParentState')">{{ $t('components.service.Registration.48') }}</span></div>
        </template>

        <!-- успех регистрации — карточка вместо модалки (#9) -->
        <template v-else>
            <Stages :stage="4" :stages="this.stages" style="margin-bottom: 28px"/>
            <div class="auth-ok-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg></div>
            <div class="form-head">
                <h1 class="form-title" style="font-size: 24px">{{ $t('components.service.Registration.28') }}</h1>
                <p class="form-sub">{{ this.successManual ? $t('components.service.Registration.31') : ($t('components.service.Registration.29') + $t('components.service.Registration.30')) }}</p>
            </div>
            <Button :name="$t('components.service.Registration.48')" type="btn-warning" :style="'width: 100%'" v-on:click="this.$emit('updateParentState')"/>
        </template>
    </div>
</template>

<script>
import InputSimple from '@/components/service/InputSimple';
import Button from '@/components/service/Button';
import Stages from '@/components/virtAct/Stages';
import Loading from 'vue-loading-overlay';
import SelectSimple from '@/components/service/SelectSimple';
import OtpInput from '@/components/service/OtpInput';
import PasswordMeter from '@/components/service/PasswordMeter';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: {
        InputSimple,
        Button,
        Stages,
        Loading,
        SelectSimple,
        OtpInput,
        PasswordMeter,
    },
    data() {
        return {
            stages: [
                { stage: 0, ready: false, name: this.$t('components.service.Registration.24') },
                { stage: 1, ready: false, name: this.$t('components.service.Registration.25') },
                { stage: 2, ready: false, name: this.$t('components.service.Registration.26') },
                { stage: 3, ready: false, name: this.$t('components.service.Registration.42') },
            ],
            registeredUid: null,
            confirmCode: '',
            confirmCodeError: false,
            confirmCodeErrorText: '',
            resendDisabled: false,
            resendTimer: 0,
            resendInterval: null,
            stage: 0,
            usertype: false,
            continue: false,
            timeout: false,
            warn: false,
            w_time: false,
            rep_pas_warn: false,
            rep_pas_success: false,
            success: false,
            loader: false,
            // Точечные лоадеры сабмитов регистрации (mini-спиннер на кнопке).
            submitting: false,
            confirming: false,
            resending: false,
            pwValid: false,
            done: false,
            successManual: false,
            submitError: '',
            warnHint: 'Unexpected warning',
            reg_name: false,
            countries_keywords: [],
            regExp: {
                // Unicode-буквы + дефис/апостроф (#1). ПРИ ИЗМЕНЕНИИ — синхронно в PHP (LoginController).
                surname: /^[\p{L}\-'’]{1,300}$/u,
                firstname: /^[\p{L}\-'’]{1,300}$/u,
                uname: /^(?!\s*$).+/,
                patronymic: /^[\p{L}\s\-'’]{1,300}$/u,
                email: /^((([A-Za-z]|[0-9]|!|#|\$|%|&|'|\*|\+|\-|\/|=|\?|\^|_|`|\{|\||\}|~)+(\.([A-Za-z]|[0-9]|!|#|\$|%|&|'|\*|\+|\-|\/|=|\?|\^|_|`|\{|\||\}|~)+)*)@((((([A-Za-z]|[0-9])([a-z]|[0-9]|\-){0,61}([A-Za-z]|[0-9])\.))*([A-Za-z]|[0-9])([A-Za-z]|[0-9]|\-){0,61}([A-Za-z]|[0-9])\.)[\w]{2,30}|(((([0-9]){1,3}\.){3}([0-9]){1,3}))|(\[((([0-9]){1,3}\.){3}([0-9]){1,3})\])))$/,
                password: /^[0-9a-zA-Z_\-\.\!\@\$\%\^\*\=\#\~]{5,63}$/,
                legal_entity_identifier: /^(?!\s*$).+/,
            },
            inpts: {
                surname: { warn: false, success: false, time: false },
                firstname: { warn: false, success: false, time: false },
                patronymic: { warn: false, success: false, time: false },
                uname: { warn: false, success: false, time: false },
                legal_entity_identifier: { warn: false, success: false, time: false },
                password: { warn: false, success: false, time: false },
            },
            data: {
                surname: '',
                firstname: '',
                patronymic: '',
                email: '',
                password: '',
                rep_password: '',
                uname: '',
                legal_entity_identifier: '',
                fact_country: '',
            },
        };
    },
    mounted() {
        this.reg_name = this.$store.state.config['REGISTER_WITH_NAME'];
        if (this.$route.query.usertype) {
            this.typeChange();
            if (this.$route.query.usertype == 'natural') {
                this.usertype = '1';
                this.stages[0].ready = true;
                this.goNext();
            } else if (this.$route.query.usertype == 'legal') {
                this.usertype = '2';
                this.stages[0].ready = true;
                this.goNext();
            }
        }
    },
    computed: {
        regMatch() {
            return this.data.password.length > 0 && this.data.password === this.data.rep_password;
        },
    },
    methods: {
        selectType(t) {
            this.typeChange();
            this.usertype = t;
            this.stages[0].ready = true;
        },
        updateState(state) {
            this.data[state.id] = state.value;
            this.checkParams();
        },
        getCountryCode() {
            // #10 — ip-api.com убран (mixed-content на https + внешний логирующий сервис).
            // Определения страны по IP бэк не отдаёт — просто грузим список, юзер выбирает сам.
            this.axios.post('GetlistCountries', { no_loader: true }).then(res => {
                if (res.data.body.result == '0') {
                    let list = [];
                    res.data.body.tables[0].colvalues.forEach(e => {
                        e.value = e.country;
                        list.push(e);
                    });
                    this.countries_keywords = list.sort((a, b) => a.value.localeCompare(b.value));
                }
            });
        },
        blurCheck(state) {
            if (!this.checkReg(state)) {
                return;
            }
            if (state.id == 'email') {
                this.searchMember(state.value, state.id);
            }
            this.checkParams();
        },
        goBack() {
            if (this.stage == '0') {
                this.$emit('updateParentState');
            } else {
                this.changeStage(-1);
            }
        },
        goNext() {
            if (this.stage == '2') {
                this.doRegister();
            } else {
                this.changeStage(+1);
            }
        },
        changeStage(i, s = this.stage) {
            this.submitError = '';
            if (s === false) {
                this.stage = false;
                return;
            }
            if (s + i < 0 || s + i > 2) {
                return;
            }
            if (!this.stages[this.stage].ready && s + i > this.stage) {
                return;
            }
            this.stage = s + i;
        },
        updateStage(i) {
            this.changeStage(0, i);
        },
        checkReg(state) {
            if (this.regExp[state.id]) {
                this.warnHint = this.$t('components.service.Registration.27');
                if (this.regExp[state.id].test(state.value)) {
                    if (state.id == 'email') {
                        this.warn = false;
                    } else {
                        this.inpts[state.id].warn = false;
                        this.inpts[state.id].success = true;
                    }
                    return true;
                } else {
                    if (state.id == 'email') {
                        this.warn = true;
                        this.success = false;
                    } else {
                        this.inpts[state.id].warn = true;
                        this.inpts[state.id].success = false;
                    }
                    return false;
                }
            } else {
                return true;
            }
        },
        typeChange() {
            this.warn = false;
            this.success = false;
            this.timeout = false;
            this.pwValid = false;
            this.rep_pas_warn = false;
            this.rep_pas_success = false;
            this.data = {
                surname: '',
                firstname: '',
                patronymic: '',
                email: '',
                password: '',
                rep_password: '',
                uname: '',
                legal_entity_identifier: '',
                fact_country: '',
            };
            this.getCountryCode();
            this.checkParams();
        },
        searchMember(arg, type) {
            this.warn = false;
            this.success = false;
            this.member = false;
            let data = {};
            data[type] = arg;
            this.loader = true;
            this.axios.post('checkUnique', { no_loader: true, data: data }).then(res => {
                this.loader = false;
                if (res.data.body.result != '0') {
                    this.warnHint = res.data.body.result_text;
                    this.warn = true;
                    this.success = false;
                    return;
                } else {
                    this.warn = false;
                    this.success = true;
                    this.stages[1].ready = true;
                }
            });
        },
        checkParams() {
            if (this.usertype == '1') {
                this.stages[1].ready = !!this.success;
            } else if (this.usertype == '2') {
                this.stages[1].ready = !!(this.data.uname && this.success && this.data.legal_entity_identifier);
            }
            // #4 — пароль не обязан быть «сильным»: достаточно валидного по бэк-regex (мин 5).
            this.stages[2].ready = this.regExp.password.test(this.data.password) && this.checkRepPassword();
        },
        checkRepPassword() {
            if (this.data.password.length >= 4 && this.data.password === this.data.rep_password) {
                this.rep_pas_warn = false;
                this.rep_pas_success = true;
                return true;
            }
            if (this.data.rep_password.length > 0) {
                this.rep_pas_warn = true;
                this.rep_pas_success = false;
            }
            return false;
        },
        doRegister() {
            let data = {};
            for (let key in this.data) {
                if (this.data[key] != '') {
                    data[key] = this.data[key];
                }
            }
            data['usertype'] = this.usertype;
            delete data.rep_password;
            this.submitError = '';
            this.submitting = true;
            this.axios.post('registerMe', { no_loader: true, data: data }).then(res => {
                const body = res.data.body || {};
                if (body.result == '0') {
                    if (body.type == 'EMAIL' && body.uid) {
                        // Требуется подтверждение — показываем ввод кода.
                        this.registeredUid = body.uid;
                        this.stage = 3;
                        this.startResendTimer();
                        return;
                    }
                    // #9 — успех показываем картой (этот компонент), а не модалкой Answer.
                    this.successManual = body.type == 'MANUAL';
                    this.done = true;
                } else if (body.result != undefined && body.result != 0 && !res.data.error && !res.data.modal) {
                    // Закрытие пробела: голый result!=0 без флагов error/modal — инлайн у кнопки.
                    this.submitError = body.result_text || this.$t('views.Login.47');
                }
            }).catch(() => {
                this.submitError = this.$t('views.Login.47');
            }).finally(() => { this.submitting = false; });
        },
        onConfirmCode(v) {
            this.confirmCode = v;
            this.confirmCodeError = false;
        },
        changeEmail() {
            // #7 — вернуться к шагу данных, чтобы исправить email
            if (this.resendInterval) clearInterval(this.resendInterval);
            this.resendDisabled = false;
            this.confirmCode = '';
            this.confirmCodeError = false;
            this.stage = 1;
        },
        doConfirm() {
            if (this.confirmCode.length != 6) return;
            this.confirming = true;
            this.axios.post('confirmRegistration', { no_loader: true, data: { uid: this.registeredUid, confirm_code: this.confirmCode } }).then(res => {
                if (res.data.body && res.data.body.result == '0') {
                    // #9 — после подтверждения email тоже показываем success-карту.
                    this.successManual = false;
                    this.done = true;
                } else {
                    // красная рамка OTP — всегда; инлайн-текст только если ошибку не показал тост/модалка (без дубля).
                    this.confirmCodeError = true;
                    this.confirmCodeErrorText = (!res.data.error && !res.data.modal)
                        ? ((res.data.body && res.data.body.result_text) || this.$t('components.service.Registration.43'))
                        : '';
                }
            }).catch(() => {
                this.confirmCodeError = true;
                this.confirmCodeErrorText = this.$t('components.service.Registration.43');
            }).finally(() => { this.confirming = false; });
        },
        doResend() {
            if (this.resendDisabled) return;
            this.resending = true;
            this.axios.post('resendConfirmation', { no_loader: true, data: { uid: this.registeredUid } }).then(() => {
                this.startResendTimer();
            }).finally(() => { this.resending = false; });
        },
        startResendTimer() {
            this.resendDisabled = true;
            this.resendTimer = 60;
            if (this.resendInterval) clearInterval(this.resendInterval);
            this.resendInterval = setInterval(() => {
                this.resendTimer--;
                if (this.resendTimer <= 0) {
                    clearInterval(this.resendInterval);
                    this.resendDisabled = false;
                }
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
// Спиннер проверки e-mail на уникальность — прижат к правому краю поля.
.email-check-spinner {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible;
    pointer-events: none;
    z-index: 3;
}
.email-check-spinner :deep(.vl-overlay) {
    position: static !important;
    inset: auto !important;
    min-width: 0 !important;
    min-height: 0 !important;
    overflow: visible !important;
}
.email-check-spinner :deep(.vl-icon),
.email-check-spinner :deep(.vl-background) {
    overflow: visible !important;
}
</style>
